// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1R8Cm","input":"styles_input__1pR8q"};